/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/


/**
* A View for displaying lists.
*/
define([
    "component!base",
    "client/views/label",
    "utils/array",
    "i18n/i18n",
    "underscore",
    "jquery"
  ], function(
    Base,
    LabelView,
    ArrayUtils,
    i18n,
    _,
    $
  ) {

  var Children = function () {
    this.instances = [];
  }

  Children.prototype = {

    push: function (view) {
      if (!view) return;

      var that = this,
          originalRemove = view.remove;

      view.remove = function () {
        that.instances = _.without(that.instances, this);
        originalRemove.apply(this, arguments);
        view.remove = originalRemove;
      };

      this.instances.push(view);
    },

    remove: function (view) {
      if (view) {
        this.instances = _.without(this.instances, view);
      } else {
        _.forEach(this.instances, function(view) {
          view.remove();
        });
        this.instances = [];
      }
    }

  }


  var ListView = Base.extend({

    tagName: "ul",
    className: "nav nav-stacked nav-pills",

    defaultOptions: {
      entryTagName: "li"
    },

    initialize: function () {
      Base.prototype.initialize.apply(this, arguments);

      var that = this;
      this.children = new Children();

      _.each(this.model && this.model.models, function (child) {
        that.addOne(child, that.model, that.options);
      });

    },

    setModel: function () {
      Base.prototype.setModel.apply(this, arguments);

      if (this.model) {
         this.listenTo(this.model, "add", this.addOne);

         this.listenTo(this.model, "remove", function(m) {          
          var at = _.indexOf(this.model.models, m);
          if(this.$el.find(" > li").eq(this.options.showMoreAfter).length===0) {            
            if(at === -1) {
              this.$el.find(" > li.li-sub ul li").eq(0).insertBefore(this.$el.find(' > li').eq(this.options.showMoreAfter-1));  
            } else if(at > -1) 
              this.$el.find(" > li.li-sub ul li").eq(at - this.options.showMoreAfter).insertBefore(this.$el.find(' > li').eq(this.options.showMoreAfter-1));  
          }
        }); 

        this.listenTo(this.model, "change", function(m) {
          if(m && m.changed && m.changed.selected && this.model.models) {
              var at = _.indexOf(this.model.models, m);
        
              if ( at >= this.options.showMoreAfter ) {
                this.$el.find(" > li.li-sub ul li").eq(at - this.options.showMoreAfter).insertBefore(this.$el.find(' > li').eq(this.options.showMoreAfter-1))
                if (this.$el.find(' > li.li-sub ul li').length>0) 
                  this.$el.find(" > li").eq(this.options.showMoreAfter).insertBefore(this.$el.find(' > li.li-sub ul li').eq(0))
                else 
                  this.$el.find(" > li").eq(this.options.showMoreAfter).appendTo(this.$el.find(' > li.li-sub ul'))
              
                ArrayUtils.move(this.model.models, at, this.options.showMoreAfter-1);
              } 

            }
        });
      }
    },

    setEditable: function () {
    },

    createEntryView: function (options) {
      // If not set use default LabelView below
      if (options.childViewConstructor === undefined) {
        delete options.childViewConstructor;
      }

      return new this.constructor.EntryView(_.extend({
            application: this.options.application,
            tagName: this.options.entryTagName,
            className: this.options.entryClassName,
            role: this.options.entryRole,
            childViewConstructor: options.childViewConstructor || this.options.childViewConstructor || LabelView,
            referenceList: this.children,
            parent: this.options.parent,
            toggleChildrenOption: this.options.toggleChildrenOption
          },
          options
      )).render();
    },

    addOne: function (model, collection, options) {
      options = options || {}

      var at = typeof options.at === "undefined" ? collection && _.indexOf(collection.models, model) : options.at;
      var view = this.createEntryView({
        model: model
      });

      this.children.push(view);

      if(at == this.options.showMoreAfter) {
        var lisub = document.createElement("li");
        lisub.className = "li-sub";
        var span = document.createElement("span");
        span.setAttribute("data-i18n", "show_more");
        span.appendChild(document.createTextNode(i18n("show_more")));
        lisub.appendChild(span);
        var ul = document.createElement("ul");
        ul.className = "ul-sub";
        lisub.appendChild(ul);
        this.insertAt(lisub, at);
        ul.appendChild(view.el);
      } else if (at > this.options.showMoreAfter && at < this.model.models.length) {
        var ul = document.getElementsByClassName("ul-sub");
        ul[0].appendChild(view.el);
      } else {
        this.insertAt(view.el, at);
      }

    },

    remove: function(model) {
      if (model && model !== this.model) return; // don't delete for other models
      this.children.remove();
      Base.prototype.remove.apply(this, arguments);
    }

  });

  ListView.EntryView = Base.extend({
    tagName: "li",

    initialize: function () {
      var options = _.clone(this.options);
      delete options.tagName;
      delete options.className;

      this.childView = this.createChildView(options);
      if (this.childView) this.childView.render();
      Base.prototype.initialize.apply(this, arguments);
      if (this.childView && this.childView.el) {
        this.insertAt(this.childView.el, 0);
      }
    },

    setEditable: function () {
    },

    createChildView: function (options) {
      return new this.options.childViewConstructor(options);
    },

    setModel: function () {
      Base.prototype.setModel.apply(this, arguments);
      if (this.childView) {
        this.childView.setModel(this.model);
      }
    },

    remove: function (model) {
      if (model && model !== this.model) return; // don't delete for other models

      if (this.options.referenceList) this.options.referenceList.remove(this);

      if (this.childView) {
        this.childView.remove();
        delete this.childView;
      }
      Base.prototype.remove.apply(this, arguments);
    }
  });

  return ListView;
});
